import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CSVReader } from "react-papaparse";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
  paper: {
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const UploadFile = (props) => {
  const {
    receiptData,
    receiptHeadersIndex,
    handleChangeReceiptData,
    handleClickOldExport,
    errorInfo,
    setErrorInfo,
  } = props;
  const classes = useStyles();

  const handleOnDrop = (data, file) => {
    if (errorInfo.error) {
      setErrorInfo({ error: false, message: "" });
    }

    handleChangeReceiptData(data, file);
  };

  return (
    <div className={classes.paper}>
      <Grid
        container
        spacing={2}
        style={{ justifyContent: "center", textAlign: "center" }}
      >
        <Grid item xs={12} sm={12}>
          <Typography component="h4">
            Upload a CSV or XLSX file providing receipt information.
          </Typography>
        </Grid>
        {errorInfo.error ? (
          <Grid item xs={12} sm={12}>
            <Typography component="h4" color="error">
              {errorInfo.message}
            </Typography>
          </Grid>
        ) : (
          <></>
        )}
        <Grid item xs={6} sm={6}>
          <CSVReader
            onDrop={handleOnDrop}
            accept="text/csv, .csv, .xlsx"
            noDrop
          ></CSVReader>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 50 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClickOldExport}
            className={classes.button}
            disabled={
              errorInfo.error ||
              !receiptData.length ||
              receiptHeadersIndex <= 14
            }
          >
            Export to Old Format
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default UploadFile;
